import { leistungen } from '../../../mocks/leistungen';

interface LeistungenNavProps {
  activeId: string;
  onSelect: (id: string) => void;
}

export default function LeistungenNav({ activeId, onSelect }: LeistungenNavProps) {
  return (
    <nav className="sticky top-20 z-30 bg-white border-b border-gray-100" id="leistungen-liste">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="relative">
          {/* Right fade hint for mobile scroll */}
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none z-10 sm:hidden" />
          <div className="flex gap-1 overflow-x-auto scrollbar-hide py-3 pr-8 sm:pr-0">
            {leistungen.map((l) => (
              <button
                key={l.id}
                onClick={() => onSelect(l.id)}
                className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer flex-shrink-0 ${
                  activeId === l.id
                    ? 'bg-[#0D2B4E] text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={l.icon} />
                </div>
                <span className="hidden sm:inline">{l.title}</span>
                <span className="sm:hidden text-xs">{l.title.split(' ')[0]}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
